import { useTheme } from '@mui/material';
/**
 * Custom hook to generate responsive carousel configuration
 * Eliminates code duplication across carousel components
 */
export const useCarouselResponsive = () => {
    const theme = useTheme();
    const { sm, md, xl } = theme.breakpoints.values;
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: xl },
            items: 4,
        },
        small: {
            breakpoint: { max: xl - 1, min: md },
            items: 3,
        },
        tablet: {
            breakpoint: { max: md - 1, min: sm },
            items: 2,
        },
        mobile: {
            breakpoint: { max: sm - 1, min: 0 },
            items: 1,
        },
    };
    return responsive;
};
